import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initializeSlider = (wrapper) => {
  const slider = wrapper.querySelector('.swiper');
  const buttonPrev = wrapper.querySelector('.swiper-button-prev');
  const buttonNext = wrapper.querySelector('.swiper-button-next');
  const progressBar = wrapper.querySelector('.swiper-pagination');
  const count = wrapper.dataset.count;
  const isSliderDesktop = wrapper.classList.contains('mt-image-link-boxes--is-slider-desktop');
  let swiper = null;
  let swiperInitialized = false;

  const swiperOptions = {
    modules: [Navigation, Pagination],
    slidesPerView: 1.3,
    spaceBetween: 24,
    init: false,
    breakpoints: {
      801: {
        slidesPerView: 2,
      },
      1089: {
        slidesPerView: count,
      },
    },
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    pagination: {
      el: progressBar,
      type: 'progressbar',
    },
  };

  const initializeSwiper = () => {
    swiper.init();
    swiperInitialized = true;
    wrapper.classList.add('swiper-initialized');
  };

  const destroySwiper = () => {
    if (swiper) {
      swiper.destroy();
      swiper = null;
      swiperInitialized = false;
      wrapper.classList.remove('swiper-initialized');
    }
  };

  const resizeHandler = debounce(() => {
    const shouldInitialize = isSliderDesktop || window.innerWidth <= 1088;
    if (shouldInitialize) {
      if (!swiper) {
        swiper = new Swiper(slider, swiperOptions);
        initializeSwiper();
      }
    } else if (swiperInitialized) {
      destroySwiper();
    }
  }, 100);

  resizeHandler();

  window.addEventListener('resize', resizeHandler);
};

const debounce = (func, timeout) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const addSlider = () => {
  const wrappers = document.querySelectorAll('.mt-image-link-boxes');

  if (wrappers.length) {
    wrappers.forEach(initializeSlider);
  }
};

document.addEventListener('DOMContentLoaded', addSlider);
